import { NgModule } from '@angular/core'
import type { Routes } from '@angular/router'
import { RouterModule } from '@angular/router'

import { articlePurchaseCheckoutGuard } from '../../guards/article-purchase-checkout.guard'
import { redirectLoginGuard } from '../../guards/redirect-login.guard'
import {
  ArticleDetailsComponent,
  articleDetailsResolver,
  articleSeo,
} from './article-details/article-details.component'
import { ArticlePurchaseShellComponent } from './article-purchase/article-purchase-shell.component'
import { ArticlePurchaseAccountRegisterComponent } from './article-purchase/purchase-account-register/article-purchase-account-register.component'
import { ArticlePurchaseAccountUpdateComponent } from './article-purchase/purchase-account-update/article-purchase-account-update.component'
import { ArticlePurchaseAccountVerifyComponent } from './article-purchase/purchase-account-verify/article-purchase-account-verify.component'
import { ArticlePurchaseCheckoutComponent } from './article-purchase/purchase-checkout/article-purchase-checkout.component'
import { ArticlePurchaseContinueEmailComponent } from './article-purchase/purchase-continue-email/article-purchase-continue-email.component'
import { ArticlePurchaseSuccessComponent } from './article-purchase/purchase-success/article-purchase-success.component'

const routes: Routes = [
  {
    path: ':id/purchase',
    component: ArticlePurchaseShellComponent,
    children: [
      {
        path: 'success',
        component: ArticlePurchaseSuccessComponent,
        canActivate: [redirectLoginGuard],
        data: { purchaseStep: 'success' },
      },
      {
        path: 'continue-in-email',
        component: ArticlePurchaseContinueEmailComponent,
        canActivate: [redirectLoginGuard],
        data: { purchaseStep: 'continueEmail' },
      },
      {
        path: 'account/register',
        component: ArticlePurchaseAccountRegisterComponent,
        data: { purchaseStep: 'account' },
      },
      {
        path: 'account/verify',
        component: ArticlePurchaseAccountVerifyComponent,
        data: { purchaseStep: 'verify' },
      },
      {
        path: 'account/update',
        component: ArticlePurchaseAccountUpdateComponent,
        canActivate: [redirectLoginGuard],
        data: { purchaseStep: 'account', includeVerificationStep: false },
      },
      {
        path: '',
        component: ArticlePurchaseCheckoutComponent,
        canActivate: [articlePurchaseCheckoutGuard],
        data: { purchaseStep: 'checkout' },
      },
    ],
  },
  {
    path: ':id',
    component: ArticleDetailsComponent,
    resolve: { articleDetails: articleDetailsResolver },
    data: { seo: articleSeo },
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ArticlesRoutingModule {}
